import React, { Component } from "react";
import { withRouter } from "react-router";
import { Api } from "../utils/api";

import { Field, Formik } from 'formik';
import { MaterialSelectFormik } from '../user_requests/components/select-field.component';
import Grid from '@material-ui/core/Grid';
import {date, number, object, string} from 'yup';
import { DatePicker } from '../components/datetime-picker.component';
import moment from 'moment';
import AlertDialog from '../components/alert.component';
import CallTypesTable from "./components/call_types_table.component";

import { TimePicker } from 'antd';

class CallTypesView extends Component {

  constructor() {
    super();
    this.api = new Api();
    this.getCallRegists = this.getCallRegists.bind(this);
    this.updateCallRegist = this.updateCallRegist.bind(this);
    //this.deleteCallRegist = this.deleteCallRegist.bind(this);
    this.showAlert = this.showAlert.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
    this.refreshPage = this.refreshPage.bind(this);
    this.rowsPerPage = 5;
  }

  state = {
    callRegists:null,
    showAlert:false,
    alertTitle:"",
    alertMessage:""
  };

  componentDidMount() {
    this.getCallRegists();
  }

  getCallRegists(page=0, per_page=this.rowsPerPage, search="") {
    return this.api.get(`/call_regists`,{page:page+1,per_page,search})
    .then(({data = null}) => {
      this.setState({callRegists: data});
      return data;
    }); 
  }

  
  updateCallRegist(id,newData) {
    return this.api.patch(`call_regists/${id}`,{...newData})
    .then(({data = null}) => {
      this.setState({callRegist: data});
      return data;
    })
    .catch(({data = null}) => {
      this.setState({callRegist: data});
      return data;
    });
  }

  /* MÉTODO de APAGAR REGISTOS ////////////////////////

  deleteCallRegist(id) {
    return this.api.delete(`call_regists/${id}`);
  } 
  */
  
  refreshPage() {
    window.location.reload();
  }

  showAlert(title,message) {
    this.setState({showAlert: true});
    this.setState({alertTitle: title});
    this.setState({alertMessage: message});
  };

  closeAlert() {
    this.setState({showAlert: false});
  };

  render() {

    const current = new Date();
    const today = `${current.getFullYear()}-${current.getMonth()+1}-${current.getDate()}`;

    const validationSchema = object().shape({
      social_worker_id: number().required("Obrigatório"),
      phone_number: string().required("Obrigatório"),
      call_type_id: number().required("Obrigatório"),
      callday: date().required("A data não pode ser superior ao dia de hoje").max(today),
      hour: string().required("Obrigatório")
    });


    const typesToSelect = (options) => {
      return options.map(
        (option) => ({ value: option.id, label: option.types })
      );
    };

    const callTypesOptionsPromise = () => {
      const api = new Api();
      return api.get('/call_types')
        .then(res => res.data)
        .then(typesToSelect);
    };


    const CallTypePromisse = (data) => {
      const api = new Api();
      return api.post(`/call_regists`, data)
        .then(res => {
          console.log(res.json);
          this.showAlert("Sucesso","Classificado com sucesso!");
        })
        .catch(err => {
          console.log(err);
          this.showAlert("Erro","Ocorreu um erro ao gravar!");
        })
    };

    return (
    <div class="container">
      <div class="w-50 mx-auto">
        <h1 class="h5 text-center mb-4 pt-4 pb-4 text-primary">Tipificar Contacto</h1>
        <Grid item md={12}>
          <Formik
            initialValues={{ social_worker_id: localStorage.id, phone_number: '', call_type_id: '', callday: moment().format('YYYY-MM-DD'), hour: moment().format('HH:mm') }} 
            validationSchema={validationSchema}
            validateOnChange={true}
            validateOnBlur={true}   
            onSubmit={(values, { setSubmitting }) => {
              setTimeout(() => {
                console.log(JSON.stringify(values, null, 2));
                CallTypePromisse(values)
                  .then(() => {
                    setSubmitting(false);
                    this.refreshPage();
                  });
              }, 400);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue, 
              setFieldTouched,
              handleInputChange,
            }) => (
              <form onSubmit={handleSubmit}>
                <div class="form-group">
                  <div // ID DA ASSISTENTE SOCIAL
                    type="hidden"
                    name="social_worker_id"
                  />

                  <div> <label>Número de telefone: </label>
                    <Field// NÚMERO DE TELEFONE
                      class="form-control mb-1 p-3"
                      name="phone_number" 
                      type="text"
                      required
                      onChange={handleChange}
                      value={values.phone_number}
                      fullWidth
                    /> 
                  </div>

                  <div class="mb-2 mt-2"> 
                    <Field // CLASSIFICAÇAO DA CHAMADA
                      class="form-control mb-1"
                      search
                      label="Tipo de chamada"
                      name="call_type_id"
                      optionsFetcher={callTypesOptionsPromise}
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      value={values.call_type_id} 
                      component={MaterialSelectFormik}
                    /> 
                  </div> 

                  <div class="mb-4 mt-2"> <label>Data da chamada: </label>
                    <input // DIA DA CHAMADA
                      class="form-control mb-1"
                      name="callday" 
                      type="date"
                      required
                      margin="normal"
                      onChange={handleChange}
                      component={DatePicker}
                      value={values.callday}
                      fullWidth
                    />
                  </div>

                  <div class="mb-4 mt-2"> <label>Hora da chamada: </label>
                    <input // Hora DA CHAMADA
                      class="form-control mb-1"
                      name="hour" 
                      type="time"
                      required
                      margin="normal"
                      onChange={handleChange}
                      component={ TimePicker }
                      value={values.hour}
                      fullWidth
                    />
                  </div>

                  <div class="text-center">
                    <button 
                      type="submit" 
                      class="btn btn-primary mt-1" 
                      disabled={isSubmitting}
                      >
                      Tipificar
                    </button>
                  </div>
                </div>
              </form>
            )}
          </Formik>
        </Grid>
        <AlertDialog
          open={this.state.showAlert}
          handleClose={this.closeAlert}
          title={this.state.alertTitle}
          message={this.state.alertMessage}
          >
        </AlertDialog> 
      </div>

      <div class="mt-4 pt-4">
       <h1 class="h3 bg-dark text-white p-2 pl-4">Registos</h1> 
          <CallTypesTable
            handleRefresh={this.getCallRegists}
            handleUpdate={this.updateCallRegist}
            //handleDelete={this.deleteCallRegist}
            refreshPage={this.refreshPage}
          />
      </div>
    </div>
    );
  }
}
export default withRouter(CallTypesView);

